var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusGifts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2.583a.75.75 0 0 1 .75.75v9.334a.75.75 0 1 1-1.5 0V3.333a.75.75 0 0 1 .75-.75"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.083 8a.75.75 0 0 1 .75-.75h9.333a.75.75 0 1 1 0 1.5H3.833a.75.75 0 0 1-.75-.75"
})));
export default SvgPlusGifts;